'use client'

import { useEffect, useState } from 'react'

export function useSellerId() {
  const [sellerId, setSellerId] = useState<number | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    async function fetchSellerId() {
      try {
        setLoading(true)
        setError(null)

        const res = await fetch('/api/seller/resolve', {
          credentials: 'include',
          cache: 'no-store',
        })

        const data = await res.json().catch(() => null)

        if (!res.ok || !data?.ok) {
          throw new Error(data?.error || 'failed_to_resolve_seller')
        }

        const nextSellerId = Number(data?.sellerId || data?.customer_id || 0)

        if (!nextSellerId) {
          throw new Error('missing_seller_id')
        }

        if (!cancelled) {
          setSellerId(nextSellerId)
        }
      } catch (err) {
        console.error('[useSellerId] Error fetching seller ID:', err)

        if (!cancelled) {
          setSellerId(null)
          setError(err instanceof Error ? err.message : 'unknown_error')
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    fetchSellerId()

    return () => {
      cancelled = true
    }
  }, [])

  return { sellerId, loading, error }
}